
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LookupClientEntitiesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"entities"},"name":{"kind":"Name","value":"clientEntitiesByIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subaccounts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subAccountId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subAccountType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subAccountStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignedCommonOrgId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"caId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"custName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"custType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"custPhoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addrLine1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addrLine2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postalCd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"provinceCd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryFlag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryCd"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"clientNameplates"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oemAbbreviation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nameplateDesc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oemLocationId"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":504}};
    doc.loc.source = {"body":"query LookupClientEntitiesByIds($ids: [String]!) {\n  entities: clientEntitiesByIds(ids: $ids) {\n    subaccounts {\n      subAccountId\n      subAccountType\n      subAccountStatus\n      assignedCommonOrgId\n    }\n    caId\n    custName\n    custType\n    custPhoneNumber\n    addresses {\n      addrLine1\n      addrLine2\n      postalCd\n      city\n      provinceCd\n      primaryFlag\n      countryCd\n    }\n    clientNameplates {\n      oemAbbreviation\n      nameplateDesc\n      oemId\n      oemLocationId\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["LookupClientEntitiesByIds"] = oneQuery(doc, "LookupClientEntitiesByIds");
        
